const DURATION_PATTERN = /^(\d+)个月(\d+)天$/;
const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

// 型号命名可能使用“超主点β2”“超主点-β4”或“超主点B2”等写法，统一按β标识识别。
export const isBetaHistoryModel = (value) => {
  if (typeof value !== 'string') return false;

  const normalizedValue = value
    .normalize('NFKC')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .trim();

  return /β|ϐ|Β|beta/i.test(normalizedValue)
    || /超主点[\s\-_]*b(?:eta)?\s*\d?/i.test(normalizedValue);
};

const buildDate = (year, month, day) => {
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year
    && date.getMonth() === month - 1
    && date.getDate() === day
    ? date
    : null;
};

const addCalendarMonths = (date, monthCount) => {
  const target = new Date(date.getFullYear(), date.getMonth() + monthCount, 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  return new Date(
    target.getFullYear(),
    target.getMonth(),
    Math.min(date.getDate(), lastDay)
  );
};

const calculateDateDuration = (start, today) => {
  if (start > today) return null;

  let months = (today.getFullYear() - start.getFullYear()) * 12
    + today.getMonth() - start.getMonth();
  let anniversary = addCalendarMonths(start, months);
  if (anniversary > today) {
    months -= 1;
    anniversary = addCalendarMonths(start, months);
  }

  const days = Math.floor((Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
    - Date.UTC(anniversary.getFullYear(), anniversary.getMonth(), anniversary.getDate()))
    / (24 * 60 * 60 * 1000));
  return { months: Math.max(0, months), days: Math.max(0, days) };
};

export const parseBetaHistoryDuration = (value, today = new Date()) => {
  if (typeof value !== 'string' || !value.trim()) return null;
  const normalizedValue = value.trim();
  const durationMatch = normalizedValue.match(DURATION_PATTERN);
  if (durationMatch) {
    const months = Number(durationMatch[1]);
    const days = Number(durationMatch[2]);
    return months <= 120 && days <= 31 ? { months, days } : null;
  }

  // 兼容旧版本保存的停药/停戴日期，打开或提交时转换为时长。
  const dateMatch = normalizedValue.match(DATE_PATTERN);
  if (!dateMatch) return null;
  const start = buildDate(Number(dateMatch[1]), Number(dateMatch[2]), Number(dateMatch[3]));
  if (!start) return null;
  const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return calculateDateDuration(start, currentDate);
};

export const normalizeBetaHistoryDuration = (value) => {
  const parsed = parseBetaHistoryDuration(value);
  return parsed ? `${parsed.months}个月${parsed.days}天` : '';
};
